import { render, staticRenderFns } from "./Saisondauer.vue?vue&type=template&id=4b569452&"
import script from "./Saisondauer.vue?vue&type=script&lang=js&"
export * from "./Saisondauer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports